import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

interface Update {
  id: number;
  title: string;
  category: string;
  image: string;
  excerpt: string;
  date: string;
}

const Updates: React.FC = () => {
  const [updates, setUpdates] = useState<Update[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch updates from API
    fetch('http://localhost:5000/api/updates')
      .then(res => res.json())
      .then(data => {
        setUpdates(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching updates:', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, [updates]);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160 bg-image"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">Latest Updates</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link><span><i className="fa-regular fa-angles-right mx-2"></i>Latest Updates</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {loading ? (
        <div className="text-center py-5">
          <p>Loading updates...</p>
        </div>
      ) : (
        <>
          {/* Updates area start here */}
          <section className="cause-area pt-120 pb-120">
            <div className="container">
              <div className="row g-4">
                {updates.map((update, index) => (
                  <div key={update.id} className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay={`${index * 100}ms`} data-wow-duration="1500ms">
                    <div className="cause__item">
                      <div className="cause__image image">
                        <img src={update.image} alt={update.title} style={{ width: '100%', height: '224px', objectFit: 'cover' }} />
                        <span className="cause-tag">{update.category}</span>
                      </div>
                      <div className="cause__content">
                        <h4 className="mb-4 mt-20">
                          <Link to={`/updates/${update.id}`} className="primary-hover">
                            {update.title}
                          </Link>
                        </h4>
                        <p>{update.excerpt}</p>
                        <div className="btn-three mt-30">
                          <span className="btn-circle"></span>
                          <Link to={`/updates/${update.id}`} className="btn-inner">
                            <span className="btn-text">READ MORE</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* Updates area end here */}
        </>
      )}
    </>
  );
};

export default Updates;
